<div class="content d-flex flex-column vi-gap-24">
  <headline-text [headline]="'APPOI.PROPOSAL_DECLINED.HEADLINE' | translate"
                 [text]="'APPOI.PROPOSAL_DECLINED.DESCRIPTION' | translate"
  ></headline-text>

  <mat-card>
    <mat-card-content>
      <feedback-form-declined
        (formControlOutput)="handleFeedbackForm($event)"
        (outputData)="receiveOutput($event)"
        [hideSendButton]="true"
      ></feedback-form-declined>
    </mat-card-content>
  </mat-card>

  <div class="d-flex actions">
    <button (throttledClick)="send()"
            [disabled]="!formValid"
            [gtmEventData]="{ 'flowType': 'PROPOSAL_DECLINED', 'contactReason': comment?.typeOfRequestKey }"
            [gtmEventName]="'add_note'"
            [throttleTime]="5000"
            appPreventDoubleClick
            class="vi-button"
            color="primary"
            mat-flat-button>{{ 'APPOI.BUTTON.SEND' | translate }}
    </button>
  </div>

</div>


